import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";

function Breadcrumb() {
    const {data : {about: {topbar : {data,name,caption}}}} = useGetSettingQuery()

    return ( 
        <div className="breadcrumb-section" style={{backgroundImage: data.img_image ? `url(${data.img_image})` : '/defaults/theme2/images/breadcrumb-bg-white.jpg'}}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 text-center">
                        <div className="breadcrumb-text">
                            <p>{name}</p>
                            {caption && <h1>{caption}</h1>}
                        </div>
                    </div>
                </div>
            </div>
	    </div>
    );
}

export default Breadcrumb;